// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_ValidateSetupInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /contas/contas/validate_setup/{conta_id}
 *
 * Validates account setup. No body required — conta_id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface Contas_ValidateSetupInput {}

registerContract('Contas_ValidateSetupInput', {})
